import { render, staticRenderFns } from "./imageAnnouncement.vue?vue&type=template&id=6d268528&scoped=true"
import script from "./imageAnnouncement.vue?vue&type=script&lang=js"
export * from "./imageAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./imageAnnouncement.vue?vue&type=style&index=0&id=6d268528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d268528",
  null
  
)

export default component.exports